import type { JSX, ReactNode } from 'react'

import styles from '~publish/legacy/composer/composer/components/css/ProfileSection.module.css'

export function ChannelSelectionSection({
  children,
}: {
  children: ReactNode
}): JSX.Element {
  return <section className={styles.selectionContainer}>{children}</section>
}
